import React from 'react';

const Loading = () => {
    return (
        <div>
            <section className="properties-section">
  <div className="container" style={{ 
    textAlign: "center", 
    padding: "100px 50px", 
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center" 
  }}>
    <style>
      {`
        .premium-loader {
          width: 60px;
          height: 60px;
          border: 4px solid #f3f3f3;
          border-top: 4px solid #E404E4;
          border-right: 4px solid #00C3FF;
          border-radius: 50%;
          animation: spin 1s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite;
          box-shadow: 0 0 15px rgba(228, 4, 228, 0.2);
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .loading-status {
          margin-top: 25px;
          font-size: 14px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 2px;
          background: linear-gradient(90deg, #E404E4, #00C3FF);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      `}
    </style>
    <div className="premium-loader"></div>
    <p className="loading-status">Please wait...</p>
  </div>
</section>
        </div>
    );
};

export default Loading;